import { useMemo } from 'react'
import { useFirestore } from '../../firebase/useFirestore'
import useSharedCollection from '../../firebase/useSharedCollection'
import useLocationFilter from '../../hooks/useLocationFilter'
import hasLocationFilter from '../../helpers/dashboardHelpers/hasLocationFilter'
import OutputMultiLineGraph from '../Visualisations/outputs/OutputMultiLineGraph'
import PersonasRoutesVisualization from '../dataVisualizations/PersonasRoutesVisualization'
import StaticCardLabel from './StaticCardLabel'
import DashboardCardOptions from './DashboardCardOptions'
import DashboardFilterBar from './DashboardFilterBar'
import DashboardLocationFilter from './DashboardLocationFilter'
import DashboardCardEmptyState from './DashboardCardEmptyState'
import { FILTER_EMPTY_STATE } from './dashboardEmptyStateConfig'
import { CATEGORICAL } from '../../helpers/chartPalette'
import usePersonaLocations from '../../hooks/usePersonaLocations'

// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Dashboard wrapper around the shared PersonasRoutesVisualization. Owns
// the data hooks + location filter.

const DashboardPersonaRoutesCard = ({ item }) => {
    const routes = useFirestore('PersonaRoutes')
    const personas = usePersonaLocations()
    const locations = useSharedCollection('Locations')
    const { filteredItems, selectedLocationId, setSelectedLocationId } =
        useLocationFilter(personas, { item })
    // Vaste paletkleur. Deze kaart staat alleen op het dashboard, dus er valt
    // niets te kiezen; de opgeslagen ColorOverrides blijven in Firestore staan
    // maar worden niet meer gelezen. Zie docs/patterns.md#ui-chart-palette.
    const barColor = CATEGORICAL[0]

    const data = useMemo(() => {
        const routeList = Array.isArray(routes) ? routes : []

        const countsByRouteId = filteredItems.reduce((acc, p) => {
            const key = p?.RouteID
            if (key) acc[key] = (acc[key] || 0) + 1
            return acc
        }, {})

        return routeList.map((route) => ({
            name: route.Title,
            routeId: route.ID,
            value: { total: countsByRouteId[route.ID] || 0 },
        }))
    }, [routes, filteredItems])

    const isLoading = personas === undefined
    const hasAssignments = data.some((d) => d.value.total > 0)
    const isEmpty = !isLoading && !hasAssignments
    const isFilterEmpty = isEmpty && !!selectedLocationId


    return (
        <div className='housevisits-card-body'>
            <StaticCardLabel
                title='Trajecten'
                pill={{ variant: 'personas', label: 'Medewerkers' }}
            />
            <DashboardFilterBar
                onClear={() => setSelectedLocationId('')}
                activeFilterCount={selectedLocationId ? 1 : 0}
                hasFilters={hasLocationFilter(locations)}
            >
                <DashboardLocationFilter
                    selectedLocationId={selectedLocationId}
                    onChange={setSelectedLocationId}
                />
            </DashboardFilterBar>
            <div className='housevisits-card-chart'>
                {isFilterEmpty ? (
                    <DashboardCardEmptyState
                        {...FILTER_EMPTY_STATE}
                        onCtaClick={() => setSelectedLocationId('')}
                    />
                ) : isEmpty ? (
                    <DashboardCardEmptyState type='personas-routes' />
                ) : (
                    <PersonasRoutesVisualization
                        data={data}
                        color={barColor}
                        height={'100%'}
                    />
                )}
            </div>
            <DashboardCardOptions item={item} />
        </div>
    )
}

export default DashboardPersonaRoutesCard
